import React from "react";
class AccordionTitleElement extends React.Component {
}
export default AccordionTitleElement;
